// Product Pricing API calls: PRODUCT -> SUB_PRODUCT -> RESELLER_PRICE.
//
// The server decides which reseller a caller may see — admins pass `reseller`
// explicitly, resellers have it forced to their own name and the param ignored —
// so the page can always send it and never has to branch on role for reads.
//
// A missing price comes back as `null`, never 0. Callers must render that as
// "Not configured" rather than a number.
import { api } from './api';

export const pricingApi = {
  // Products with sub-products nested. Pass a reseller to fold that reseller's
  // price into each row; omit for the all-resellers comparison.
  tree: (reseller) => api.get('/api/pricing', reseller ? { reseller } : undefined),

  products: () => api.get('/api/pricing/products'),

  // Side-panel payload: details + every reseller price + change history.
  subProduct: (id) => api.get(`/api/pricing/sub-products/${id}`),

  createProduct: (body) => api.post('/api/pricing/products', body),

  createSubProduct: (productId, body) =>
    api.post(`/api/pricing/products/${productId}/sub-products`, body),

  updateSubProduct: (id, patch) => api.patch(`/api/pricing/sub-products/${id}`, patch),

  // `expectedPrice` is the figure the panel displayed. The server refuses the
  // save if someone else has changed it since, instead of silently overwriting.
  setPrice: (subProductId, body) =>
    api.put(`/api/pricing/sub-products/${subProductId}/price`, body),

  // The grid's "Save Changes": every edited cell in one request. Resolves with
  // { applied, failed } — per-cell outcomes, because one bad row must not throw
  // away the rest of the manager's work.
  bulkSet: (resellerName, prices) => api.post('/api/pricing/prices/bulk', { resellerName, prices }),

  // A reseller is priced in one currency. This relabels every price they have —
  // the figures are not converted.
  setResellerCurrency: (resellerName, currency) =>
    api.put('/api/pricing/resellers/currency', { resellerName, currency }),

  clearPrice: (subProductId, resellerName) =>
    api.del(`/api/pricing/sub-products/${subProductId}/price?reseller=${encodeURIComponent(resellerName)}`),

  history: (params) => api.get('/api/pricing/history', params),

  matrix: () => api.get('/api/pricing/matrix'),
};
